export const mediumClues: string[] = [
  "3D Printing",
  "Air Pollution",
  "Angel",
  "Atlantis",
  "Augmented Reality",
  "Basketball",
  "Big Ben",
  "Big Data",
  "Biodiversity",
  "Biotechnology",
  "Birthday",
  "Blockchain",
  "Camping",
  "Carbon Footprint",
  "Climate",
  "Cloud Computing",
  "Colosseum",
  "Composting",
  "Contactless Payment",
  "Cooking",
  "Coral Reef",
  "Crowdfunding",
  "Cyberbullying",
  "Cybersecurity",
  "Dancing",
  "Deforestation",
  "Desert Island",
  "Digital Currency",
  "Digital Detox",
  "Digital Divide",
  "Digital Footprint",
  "Disneyland",
  "Dragon",
  "Dream",
  "Drones",
  "E-commerce",
  "E-learning",
  "Earthquake",
  "Ecosystem",
  "Egypt",
  "Eiffel Tower",
  "Einstein",
  "Electronic Waste",
  "Endangered Species",
  "Erosion",
  "eSports",
  "Financial Technology",
  "Fire",
  "Fishing",
  "Fossil Fuels",
  "Fossil",
  "Gandhi",
  "Garden",
  "Gardening",
  "Genetic Engineering",
  "Ghost",
  "Glacier",
  "Global Warming",
  "Grand Canyon",
  "Green Energy",
  "Habitat Destruction",
  "Hacking",
  "Health and Fitness Apps",
  "Hiking",
  "Identity Theft",
  "Industrialization",
  "Information Overload",
  "Internet of Things",
  "Jail",
  "Jogging",
  "Julius Caesar",
  "Jungle",
  "King",
  "Kitchen",
  "Knitting",
  "Laughing",
  "Leonardo da Vinci",
  "Light Pollution",
  "Lightning",
  "Machine Learning",
  "Malware",
  "Milky Way",
  "Mobile Apps",
  "Mona Lisa",
  "Nanotechnology",
  "Napoleon",
  "Natural Disaster",
  "Net Neutrality",
  "Night",
  "Noise Pollution",
  "Northern Lights",
  "Nursery",
  "Oasis",
  "Ocean",
  "Office",
  "Online Banking",
  "Online Education",
  "Online Privacy",
  "Oprah Winfrey",
  "Organic Farming",
  "Overfishing",
  "Overpopulation",
  "Painting",
  "Phishing",
  "Picasso",
  "Pirate",
  "Pollination",
  "Population Growth",
  "Quantum Computing",
  "Queen Elizabeth",
  "Queen",
  "Ransomware",
  "Reading",
  "Recycling",
  "Renewable Resources",
  "Robotics",
  "Romeo",
  "Safari",
  "Screen Time",
  "Seasons",
  "Singing",
  "Skiing",
  "Smart Cities",
  "Snow",
  "Snowball fight",
  "Social Media",
  "Solar System",
  "Space Exploration",
  "Streaming Services",
  "Sustainability",
  "Swimming",
  "Tarzan",
  "Technological Advancement",
  "Telecommuting",
  "Telemedicine",
  "Thunderstorm",
  "Traveling",
  "Umbrella",
  "Uncle Sam",
  "University",
  "Urban Sprawl",
  "Urbanization",
  "Van Gogh",
  "Video Games",
  "Virtual Communities",
  "Virtual Reality",
  "Walt Disney",
  "Water Pollution",
  "Wearable Technology",
  "Wedding",
  "Wildlife Conservation",
  "Writing",
  "X-ray",
  "Xena Warrior Princess",
  "Yoga",
  "Zeus",
];
